import { EntityFilter } from '@backstage/plugin-catalog-react';
import { Entity } from '@backstage/catalog-model';

export class EntityTeamFilter implements EntityFilter {
  constructor(readonly values: string[]) {}

  getCatalogFilters(): Record<string, string | string[]> {
    return { 'metadata.name': this.values };
  }
  filterEntity(entity: Entity): boolean {
    return this.values.some(v => entity.metadata?.name === v);
  }
  toQueryValue(): string[] {
    return this.values;
  }
}
